import { useQuery } from '@tanstack/react-query';

import { useApi, useAuth } from '../../hooks';

type CareTeamMember = {
  id: string
  capacity: number
  display_name: string
  healthie_id: number
}

export const useCareTeamMembers = () => {
  const { api } = useApi();
  const { userToken } = useAuth();

  const fetchCareTeamMembers = async () => {
    return await api({
      route: '/private/care-team-member/',
      token: userToken,
    })
  }

  const { data, isLoading, isError} = useQuery<CareTeamMember[], Error>({
    queryFn: () => fetchCareTeamMembers(),
    queryKey: ['care-team-members']
  }
  )

  return {
    careTeamMemberData: data,
    isLoading,
    isError
  }
}